import * as React from 'react'
import {ChangeEvent, ReactElement} from 'react'
import { StandardTextFieldProps } from '@mui/material/TextField';
import {numberOrZero} from '../../../stringHelper/stringHelpers'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'

import { TextField } from '@mui/material';

class PPNumericField extends React.Component<StandardTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps> {

    static displayName: string = 'PPNumericField'

    value: any
    private KEY_CODE_NAPIER_CONSTANT_OF_E_LOWER: number = 101
    private KEY_CODE_NAPIER_CONSTANT_OF_E_UPPER: number = 69
    private KEY_CODE_MINUS_SIGN: number = 45
    private KEY_CODE_PLUS_SIGN: number = 43
    private KEY_CODE_PERIOD_SIGN: number = 46

    private IGNORE_KEY_CODES: number[] = [
        this.KEY_CODE_NAPIER_CONSTANT_OF_E_LOWER, this.KEY_CODE_NAPIER_CONSTANT_OF_E_UPPER,
        this.KEY_CODE_MINUS_SIGN, this.KEY_CODE_PLUS_SIGN,
        this.KEY_CODE_PERIOD_SIGN,
    ]

    constructor(props: StandardTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps) {
        super(props)

        this.value = props.value

        this.handleChange = this.handleChange.bind(this)
    }

    onChange(event: ChangeEvent<HTMLInputElement>): void {
        this.value = event.target.value
        if (this.props.onChange) {
            this.props.onChange(event)
        }
        if (this.props.clearErrorMessage) {
            this.props.clearErrorMessage()
        }
    }

    handleChange(event: ChangeEvent<HTMLInputElement>): void {
        event.persist()

        if (event.target.value === '') {
            return this.onChange(event)
        }

        const inputtedValue: number = numberOrZero(event.target.value)

        if (event.target.max && inputtedValue > (Number(event.target.max))) {
            event.target.value = this.value
            return
        }

        if (event.target.min && inputtedValue < (Number(event.target.min))) {
            event.target.value = this.value
            return
        }

        this.onChange(event)
    }

    render(): ReactElement {
        const {
            type,
            hasError,
            onChange,
            onKeyPress,
            messages,
            clearErrorMessage,
            eventKeys,
            eventEmitter,
            ...rest
        } = this.props
        return (
            <TextField
                variant="standard"
                {...rest}
                error={hasError}
                type={'number'}
                onChange={this.handleChange}
                onKeyPress={(event: React.KeyboardEvent) => {
                    if (this.IGNORE_KEY_CODES.includes(event.which)) {
                        event.preventDefault()
                        return
                    }
                    if (onKeyPress) {
                        onKeyPress(event)
                    }
                }} />
        );
    }
}

export default createErrorHandlingForm(withEnterKeyHandler(PPNumericField))

